module.exports = __webpack_public_path__ + "static/media/aba_ta_ma_pani_school_jane.b3ef5459.ogg";